import { render, staticRenderFns } from "./OrderListing.vue?vue&type=template&id=d2964e4c&scoped=true&"
import script from "./OrderListing.vue?vue&type=script&lang=js&"
export * from "./OrderListing.vue?vue&type=script&lang=js&"
import style0 from "./OrderListing.vue?vue&type=style&index=0&id=d2964e4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2964e4c",
  null
  
)

export default component.exports